import { render } from "./LeagueTableChart.vue?vue&type=template&id=758a9b81"
import script from "./LeagueTableChart.vue?vue&type=script&lang=js"
export * from "./LeagueTableChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__